// @ts-nocheck
import { useEffect, useRef } from "react";

export function useSoundHook(src, options = null) {
  const audio = useRef();
  const tl = useRef();

  const play = () => {
    const sound = audio.current;

    // return;

    if (sound) {
      sound.volume = 0;
      sound.play().catch(() => {});
      tl.current?.kill();
      tl.current = gsap.to(sound, { volume: 0.5, duration: 2, ease: "none" });
    }
  };
  const stop = () => {
    const sound = audio.current;
    if (sound) {
      tl.current?.kill();
      tl.current = gsap.to(sound, {
        volume: 0,
        duration: 2,
        ease: "none",
        onComplete: () => sound.pause(),
      });
    }
  };

  useEffect(() => {
    if (!audio.current) {
      // @ts-ignore
      audio.current = new Audio(src);
    }
    const sound = audio.current;

    options &&
      Object.keys(options).forEach((key) => {
        // @ts-ignore
        sound[key] = options[key];
      });
    return () => {
      if (sound) {
        // @ts-ignore
        sound.pause();
      }
      audio.current = undefined;
    };
  }, []);

  return { play, stop, audio: () => audio.current };
}
